<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
  class="dark bg-primary-900 print:hidden"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="navigation.default"
  [opened]="!isScreenSmall">
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <div class="flex items-center w-full p-4 pl-6">
      <!-- Logo -->
      <div class="flex items-center justify-center">
        <!-- Light version -->
        <a href="/">
          <img class="dark:hidden w-36" src="assets/images/logo/logo-wa-black-yellow.svg" alt="Wine Ark logo" />
        </a>
        <!-- Dark version -->
        <a href="/">
          <img class="hidden dark:flex w-36" src="assets/images/logo/logo-wa-white-yellow.svg" alt="Wine Ark logo" />
        </a>
      </div>
      <!-- Components -->
      <div class="flex items-center ml-auto">
        <button mat-icon-button (click)="logOut()">
          <mat-icon [svgIcon]="'hero_outline:arrow-right-on-rectangle'"></mat-icon>
        </button>
      </div>
    </div>
    <!-- User -->
    <div class="flex flex-col items-center w-full p-4">
      <div class="relative w-24 h-24 rounded-full overflow-hidden">
        <mat-icon
          class="absolute icon-size-24 text-black text-opacity-20"
          [class]="'avatar-' + user?.avatar_color"
          svgIcon="hero_solid:user-circle"></mat-icon>
        <div class="absolute w-full h-full avatar-text">{{ user?.initials ?? "N/A" }}</div>
      </div>
      <div class="flex flex-col items-center justify-center w-full mt-6">
        <div class="w-full whitespace-nowrap text-ellipsis overflow-hidden text-center leading-normal font-medium">
          {{ user?.first_name }} {{ user?.last_name ?? "" }}
        </div>
        <div
          class="w-full mt-0.5 whitespace-nowrap text-ellipsis overflow-hidden text-center text-md leading-normal font-medium text-secondary">
          {{ user?.email }}
        </div>
      </div>
    </div>
  </ng-container>
  <!-- Navigation footer hook -->
  <ng-container fuseVerticalNavigationContentFooter>
    <div class="flex flex-0 flex-col items-center justify-center gap-y-2 h-16 pr-6 pl-2 mt-2 mb-4">
      <img class="max-w-52" src="assets/images/logo/logo-ns-long-grey-dark.svg" alt="National Storage logo" />
      <span class="font-medium text-primary-600">© National Storage {{ currentYear }}</span>
    </div>
  </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
  <!-- Header -->

  <div
    class="relative flex flex-0 items-center w-full h-14 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent">
    <!-- Navigation toggle button -->
    <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
      <mat-icon [svgIcon]="'hero_solid:bars-3'"></mat-icon>
    </button>
    <span class="toolbar-spacer"></span>
    <app-global-filter style="min-width: fit-content" class="mr-5 text-right"></app-global-filter>
    <mat-icon
      class="cursor-pointer global-qr-button"
      (click)="launchGlobalQrScanner()"
      [svgIcon]="'hero_solid:qr-code'"
      matTooltip="Scan QR code to quickly view item details">
    </mat-icon>
  </div>

  <!-- Content -->
  <div class="relative flex flex-col flex-auto">
    <div cdkScrollable class="absolute inset-0 flex flex-col flex-auto overflow-y-auto overflow-x-hidden">
      <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
      Otherwise, layout changes won't be registered and the view won't be updated! -->
      @if (true) {
        <router-outlet></router-outlet>
      }
    </div>
  </div>
</div>
